import { communicationsApi } from '@app/services'

import { FetchChatTokenResponse } from './types'

export const fetchChatToken = async () => {
  const { data } =
    await communicationsApi.post<FetchChatTokenResponse>('/chat/token')

  return data
}
